import type { FaireProductEntity } from "../../entity_types/product";

export const p_tffn37ns9k: FaireProductEntity = {
  token: "p_tffn37ns9k",
  type: "product",
  name: "Daisies on Green Swedish Dishcloth",
  brandToken: "b_3alvarbm",
  brandName: "Three Bluebirds Swedish Dishcloths",
  imageUrl:
    "https://cdn.faire.com/fastly/4d43161ec16932dcd2acd43d9ad6395c5ad8b3702c036bc9e48484ef9a5ac95f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8acd4e640b4f7b80e1e85c497bf79f9ea8a80752696cc514c19b4872a3f9053.png",
    "https://cdn.faire.com/fastly/477f8ff85974a0858e3927fa7a8a5d6a2f2143bef49f9b39cee89117a59e81ff.webp",
    "https://cdn.faire.com/fastly/4fe21916a327af5f89fe1e9cfe2d70ff43095cc0812828dffd98777ba96c45ff.jpeg",
  ],
  priceDollars: 3,
  description:
    "REDUCE WASTE with our Swedish Dishcloth – it’s sustainable, sturdy, and stylish.  Each cloth absorbs 20x its weight, replaces 17 rolls of paper towels.   ----   CONTENTS: 70% cellulose (FSC-Certified).  30% organic cotton (FairTrade & GOTS).  Screen printed with water-based inks.  100% biodegradable.  Designed & printed in Connecticut   ----   USE: Wash dishes.  Wipe up spills.  Clean mirrors.  Use streak-free on most surfaces.  Air dries fast, doesn’t breed bacteria like a sponge.   ----   REUSE: Wash up to 200 times, in top rack of dishwasher or in washing machine.  Sterilize in microwave or boil briefly.   ----  We include one FREE sign with your first order.  Our hand made pine wooden display box holds 75 pieces and fits this sign. Box available on our product page for $29 (see image #2).   ----    We donate 1% of revenue to the Earth for each dishcloth purchased, as a “1% for the Planet” business.  CLEAN LIFE. GREEN PLANET. MADE WITH LOVE. ",
  tags: [],
  msrpDollars: 6.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:11.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
